import { Card, CardBody, Table, TabPane } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import CreateJobPositionModal from "../Modals/CreateJobPosition";
import IconButton from "../../../../../components/Buttons/IconButton";
import { IoCreateOutline } from "react-icons/io5";
import { BsTrash3 } from "react-icons/bs";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import { del } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function JobPositionsTab({ jobPositions, refreshSettings }) {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [jobPositionToDelete, setJobPositionToDelete] = useState(null);
  const [jobPositionToEdit, setJobPositionToEdit] = useState(null);

  const deleteJobPosition = async () => {
    const data = await del(`/hr/job-positions/delete/${jobPositionToDelete}`);
    if(data?.success) {
      refreshSettings();
      setJobPositionToDelete(null);
      toast.success(t('hr.settings.jobPositions.deleted'));
    }
  }

  return(
    <TabPane tabId="job-positions">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">
              Job Positions
            </p>
            <DefaultButton
              color="primary"
              size="sm"
              onClick={() => {
                setJobPositionToEdit(null);
                setCreateModalOpen(true);
              }}
            >
              + { t('common.create') }
            </DefaultButton>
          </div>

          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{ t('common.name') }</th>
                <th>{ t('timeline.createdBy') }</th>
                <th>{ t('common.actions') }</th>
              </tr>
            </thead>
            <tbody>
              {jobPositions?.map(jobPosition => (
                <tr key={jobPosition?.id}>
                  <td>{ jobPosition?.name }</td>
                  <td>{ jobPosition?.created_by?.name }</td>
                  <td>
                    <div className="d-flex align-items-center gap-2 h-100">
                      <IconButton
                        size="sm" 
                        outline 
                        color="secondary"
                        onClick={() => {
                          setJobPositionToEdit(jobPosition);
                          setCreateModalOpen(true);
                        }}
                      >
                        <IoCreateOutline />
                      </IconButton>
                      <IconButton
                        size="sm" 
                        outline 
                        color="danger"
                        onClick={() => setJobPositionToDelete(jobPosition.id)}
                      >
                        <BsTrash3 />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <CreateJobPositionModal 
        isOpen={createModalOpen}
        toggle={() => setCreateModalOpen(!createModalOpen)}
        jobPositionToEdit={jobPositionToEdit}
        refreshSettings={refreshSettings}
      />

      <ConfirmationModal
        isOpen={jobPositionToDelete !== null}
        title={t('hr.settings.jobPositions.deleteTitle')}
        message={t('hr.settings.jobPositions.deleteMessage')}
        onConfirm={deleteJobPosition}
        toggle={() => setJobPositionToDelete(null)}
      />
    </TabPane>
  );
}

export default JobPositionsTab;